import React, { useState } from 'react';

const Careers = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    qualification: '',
    phone: '',
    currentSalary: '',
    portfolio: '',
    github: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  // Replace 'YOUR_FORM_ID' with your actual Formspree form ID for careers
  const FORMSPREE_ENDPOINT = process.env.REACT_APP_FORMSPREE_CAREERS_ID 
    ? `https://formspree.io/f/meeeadyw`
    : 'https://formspree.io/f/meeeadyw';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert(null);

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setAlert({ 
          type: 'success', 
          message: 'Thank you! We have received your application and will contact you shortly.' 
        });
        setFormData({ name: '', email: '', qualification: '', phone: '', currentSalary: '', portfolio: '', github: '', message: '' });
      } else {
        const data = await response.json();
        setAlert({ 
          type: 'error', 
          message: data.error || 'Failed to send application. Please try again.' 
        });
      }
    } catch (error) {
      setAlert({ 
        type: 'error', 
        message: 'Failed to send application. Please check your connection and try again.' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="careers" className="section">
      <div className="container">
        <h2 className="section-title">Join CompileX</h2>
        <p>We're always looking for engineers, researchers, and creators who enjoy solving hard problems.</p>
        <h3>What we value</h3>
        <ul className="check-list">
          <li><i className="fas fa-check-circle"></i> Curiosity</li>
          <li><i className="fas fa-check-circle"></i> Technical depth</li>
          <li><i className="fas fa-check-circle"></i> Ownership</li>
          <li><i className="fas fa-check-circle"></i> Continuous learning</li>
        </ul>
        <p>Send your resume or portfolio to: <a href="mailto:careers@compilex.com">careers@compilex.com</a></p>
        <h3>Apply Now</h3>
        <p>Please fill out the form below with your details. Make sure to provide accurate information to help us assess your application.</p>
        
        {alert && (
          <div className={`alert alert-${alert.type === 'success' ? 'success' : 'error'}`}>
            {alert.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="application-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">
                <i className="fas fa-user"></i> Name
              </label>
              <input type="text" id="name" name="name" placeholder="Enter your full name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="email">
                <i className="fas fa-envelope"></i> Email
              </label>
              <input type="email" id="email" name="email" placeholder="your.email@example.com" value={formData.email} onChange={handleChange} required />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="qualification">
                <i className="fas fa-graduation-cap"></i> Qualification
              </label>
              <input type="text" id="qualification" name="qualification" placeholder="e.g., Bachelor's in Computer Science" value={formData.qualification} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="phone">
                <i className="fas fa-phone"></i> Phone Number
              </label>
              <input type="tel" id="phone" name="phone" placeholder="+1 (123) 456-7890" value={formData.phone} onChange={handleChange} required />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="currentSalary">
                <i className="fas fa-dollar-sign"></i> Current Salary
              </label>
              <input type="text" id="currentSalary" name="currentSalary" placeholder="e.g., $50,000" value={formData.currentSalary} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="portfolio">
                <i className="fas fa-link"></i> Portfolio
              </label>
              <input type="url" id="portfolio" name="portfolio" placeholder="https://yourportfolio.com" value={formData.portfolio} onChange={handleChange} />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="github">
              <i className="fab fa-github"></i> GitHub
            </label>
            <input type="url" id="github" name="github" placeholder="https://github.com/yourusername" value={formData.github} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="message">
              <i className="fas fa-comment"></i> Cover Letter / Message
            </label>
            <textarea id="message" name="message" placeholder="Tell us about yourself, your experience, and why you're interested in joining CompileX..." value={formData.message} onChange={handleChange} rows="5"></textarea>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit Application'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Careers;